import type { AgGridRowData, AgGridTransactionRef } from './types';

export const addTransaction = (
  newRows: AgGridRowData[] | null | undefined,
  gridRef: AgGridTransactionRef | null | undefined
): AgGridRowData[] => {
  const api = gridRef?.current?.api;
  if (api && newRows && Array.isArray(newRows)) {
    api.applyServerSideTransaction({
      add: newRows,
      addIndex: 0
    });
    return newRows;
  } else return [];
};
